export default{
    validateCoords(coords){
        if(this.isLatLongType(coords) || this.isDMSType(coords)){
            //decimal degrees or dms type, valid
            return true
        } else {
            return false
        }
    },
    /**
     * retorna um lat/long object para ser usado no mapa
     * @param {String} coords string de coordenadas retirado da caixa (considerado que já foi validado com o 'validateCoords')
     * @returns {Object} lat/long obj
     */
    convertToDecimalDegreesObject(coords){
        if(this.isLatLongType(coords)){
            //lat long, só splitar e montar
            let a = coords.split(',');
            return {lat: parseFloat(a[0]), lng:parseFloat(a[1])}
        } else if(this.isDMSType(coords)){
            //dms, mais complexo.
            coords = this.convertToDecimalDegree(coords)            
            return {lat: coords[0], lng: coords[1]}
        }
    },
    getCoordsType(coords){
        
    },
    isLatLongType(coords){
        return coords.split(",").length == 2 && coords.split(",").every(x=> !isNaN(x))
    },
    isDMSType(coords){
        return coords.split(" ").length == 6 && coords.split(" ").every(x=> !isNaN(x))
    },
    convertToDecimalDegree(coords){
        //[0..2] = lat, [3..5] = long
        //DD = d + (min/60) + (sec/3600) formula
        coords = coords.split(' ')
        
        //variavel para guardar a lat/long convertida
        let a = []

        for(let i=0;i<coords.length;i+=3){
            try{
                let d = parseInt(coords[i]) //degree
                let m = parseInt(coords[i+1]) //min
                let s = parseInt(coords[i+2]) //sec
                
                //adicionando na variavel para retorno
                a.push(d + (m/60) + (s/3600))
            } catch(e){
                console.log('Erro ao converter de DMS para decimal')
                return null
            }
        }
        return a
    },
    //HTML STUFF
    toIncorrectState(){
        $('.find-location-box-container').addClass('error')
        $('.find-location-box-container span.error-span').addClass('show')
    },
    toDefaultState(){
        $('.find-location-box-container').removeClass('error')
        $('.find-location-box-container span.error-span').removeClass('show')
    },
    toLocatedState(){
        $('.find-location-box-container span.location-span').addClass('show')
    },
    removeLocatedState(){
        $('.find-location-box-container span.location-span').removeClass('show')
    }
    
}